import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['bundledProductsOfferRadioButton', 'productsOfferRadioButton']
  static values = {
    defaultBundledProductsOffer: { type: String },
    defaultProductsOfferRadio: { type: String },
    bundledProductsOffersPriority: { type: Array },
    dealServiceItemKeys: { type: Array }
  }

  connect() {
    $(this.element).on('change.productsSelection', 'input[type="radio"]', (event) => {
      if (this.productsOfferRadioButtonTargets.includes(event.target)) this.refreshBundledProductsOffer()
    })
  }

  disconnect() {
    $(this.element).off('change.productsSelection')
  }

  onBundledProductsOfferChange(event) {
    const mandatoryKeys = this.#mandatoryKeys(event.target)

    if (mandatoryKeys.length === 0) return

    this.#productsOfferRadioGroups().forEach(radioButtons => {
      const enabledRadioButtons = radioButtons.filter(radioButton => !radioButton.disabled)
      const radioButtonToCheck = enabledRadioButtons.find(radioButton => mandatoryKeys.includes(radioButton.dataset.serviceItemKey)) ||
                                 enabledRadioButtons.find(radioButton => radioButton.dataset.serviceItemKey === this.defaultProductsOfferRadioValue)

      if (radioButtonToCheck) this.#check(radioButtonToCheck)
    })
  }

  refreshBundledProductsOffer() {
    const displayedKeys = this.productsOfferRadioButtonTargets.map(radioButton => radioButton.dataset.serviceItemKey)
    const selectedKeys = [
      ...this.productsOfferRadioButtonTargets.filter(radioButton => radioButton.checked).map(radioButton => radioButton.dataset.serviceItemKey),
      ...this.dealServiceItemKeysValue.filter(key => !displayedKeys.includes(key))
    ]

    const matchingBundledProductsOffer = this.bundledProductsOffersPriorityValue.find(bundledProductsOffer => {
      const radioButton = this.#bundledProductsOfferRadioButton(bundledProductsOffer)
      if (!radioButton) return false

      const mandatoryKeys = this.#mandatoryKeys(radioButton)
      return mandatoryKeys.length > 0 && mandatoryKeys.every(key => selectedKeys.includes(key))
    })

    const radioButtonToCheck = this.#bundledProductsOfferRadioButton(matchingBundledProductsOffer || this.defaultBundledProductsOfferValue)

    if (radioButtonToCheck) this.#check(radioButtonToCheck)
  }

  #bundledProductsOfferRadioButton(bundledProductsOffer) {
    return this.bundledProductsOfferRadioButtonTargets.find(radioButton => radioButton.value === bundledProductsOffer)
  }

  #mandatoryKeys(bundledProductsOfferRadioButton) {
    return bundledProductsOfferRadioButton.dataset.mandatoryServiceItemKeys.split(',').filter(Boolean)
  }

  #productsOfferRadioGroups() {
    const groups = {}

    this.productsOfferRadioButtonTargets.forEach(radioButton => {
      (groups[radioButton.name] ||= []).push(radioButton)
    })

    return Object.values(groups)
  }

  #check(radioButton) {
    const sameGroupRadioButtons = this.element.querySelectorAll(`input[type="radio"][name="${radioButton.name}"]`)

    radioButton.checked = true
    $.uniform.update(sameGroupRadioButtons)

    sameGroupRadioButtons.forEach(sameGroupRadioButton => {
      sameGroupRadioButton.closest('tr')?.classList.toggle('success', sameGroupRadioButton === radioButton)
    })
  }
}
